var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3H12C12.5523 3 13 3.44772 13 4H7C7 3.44772 7.44772 3 8 3ZM6 4C6 2.89543 6.89543 2 8 2H12C13.1046 2 14 2.89543 14 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4H6ZM6 8C6 7.72386 6.22386 7.5 6.5 7.5H10.5C10.7761 7.5 11 7.72386 11 8C11 8.27614 10.7761 8.5 10.5 8.5H6.5C6.22386 8.5 6 8.27614 6 8ZM6 11C6 10.7239 6.22386 10.5 6.5 10.5H10.5C10.7761 10.5 11 10.7239 11 11C11 11.2761 10.7761 11.5 10.5 11.5H6.5C6.22386 11.5 6 11.2761 6 11ZM6.5 13.5C6.22386 13.5 6 13.7239 6 14C6 14.2761 6.22386 14.5 6.5 14.5H12.5C12.7761 14.5 13 14.2761 13 14C13 13.7239 12.7761 13.5 12.5 13.5H6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFilled);
export default __webpack_public_path__ + "static/media/task-filled.6de06c32a7ca69bdc813a9d4919239bf.svg";
export { ForwardRef as ReactComponent };